<template>
  <el-form-item
    :label="label"
    class="street-address"
    :prop="prop"
    :rules="rules"
  >
    <el-input
      v-model="streetAddress"
      type="textarea"
      :clearable="true"
      :maxlength="600"
      resize="none"
      :placeholder="placeholder"
      :disabled="disabled"
      :autofocus="autofocus"
    />
  </el-form-item>
</template>

<script>
import Validator from '@/mixins/Validator.vue'

export default {
  components: {
  },
  mixins: [
    Validator
  ],
  props: {
    value: String,
    label: {
      type: String,
      default: '住所'
    },
    prop: {
      type: String,
      default: 'street_address'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    searchCond: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      placeholder: this.searchCond ? '前方一致' : '最大600文字'
    }
  },
  computed: {
    streetAddress: {
      get () {
        return this.value
      },
      set (streetAddress) {
        this.$emit('input', streetAddress)
      }
    },
    rules: {
      get () {
        const rules = []
        if (!this.disabled) {
          if (this.required) {
            rules.push(this.validatorRequired(this.label, 'blur'))
          }
        }
        return rules
      }
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
</style>
